import { render, staticRenderFns } from "./MeterUserinfoAdjustPriceRecordList.vue?vue&type=template&id=62cc45ba&scoped=true"
import script from "./MeterUserinfoAdjustPriceRecordList.vue?vue&type=script&lang=js"
export * from "./MeterUserinfoAdjustPriceRecordList.vue?vue&type=script&lang=js"
import style0 from "./MeterUserinfoAdjustPriceRecordList.vue?vue&type=style&index=0&id=62cc45ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc45ba",
  null
  
)

export default component.exports